export const citiesOman = [
    { "title": "Muscat" },
    { "title": "Salalah" },
    { "title": "Sohar" },
    { "title": "Nizwa" },
    { "title": "Sur" },
    { "title": "Ibri" },
    { "title": "Seeb" },
    { "title": "Buraimi" },
    { "title": "Rustaq" },
    { "title": "Ibra" },
    { "title": "Khasab" },
    { "title": "Shinas" },
    { "title": "Adam" },
    { "title": "Al Hamra" },
    { "title": "Duqm" },
    { "title": "Muttrah" },
    { "title": "Al Mudhaibi" },
    { "title": "Bahla" },
    { "title": "Bidiyah" },
    { "title": "Samail" },
    { "title": "Masanah" },
    { "title": "Mahout" },
    { "title": "Wadi Bani Khalid" },
    { "title": "Jalan Bani Bu Ali" },
    { "title": "Jalan Bani Bu Hassan" }
]